import { SxProps } from '@mui/material'

interface PriceRangeStyles {
  title: SxProps
  wrapper: SxProps
  inputWrapper: SxProps
}

export const priceRangeStyles: PriceRangeStyles = {
  title: {
    typography: 'textMdSemibold',
    color: 'text.primary900',
  },
  wrapper: {
    gap: 1.5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  inputWrapper: {
    gap: 1.5,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
}
